'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'diamond-half-stroke';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M83.9 256L264 436.1 264 75.9 83.9 256z', 'M16 256L49.9 289.9 254.1 494.1 288 528 321.9 494.1 526.1 289.9 560 256 526.1 222.1 321.9 17.9 288-16 254.1 17.9 49.9 222.1 16 256zM264 436.1L83.9 256 264 75.9 264 436.1zm48 0L312 75.9 492.1 256 312 436.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;